// 리팩토링 및 PDF, Word 다운로드 기능 포함 전체 코드
// npm install html2pdf.js docx

import React, { useState } from "react";
import { useRef, useEffect } from "react";

import {
  BookOpen,
  Layers,
  ChevronDown,
  Search,
  Copy,
  UserCircle,
  Bell,
  Mail,
  Expand,
  Image,
  FileText
} from "lucide-react";

import {
  Document,
  Packer,
  Paragraph,
  Table,
  TableRow,
  TableCell,
  WidthType,
  HeadingLevel,
  AlignmentType,
  TextRun
} from "docx";

export default function LessonDashboard() {

  const topicImages = [
    "나라 소개_비즈니스 미팅에서 나라 특징 설명하기_삽화.png",
    "나라 소개_세계 문화 교류 행사에서 발표하기_삽화.png",
    "나라 소개_여행을 계획하며 나라 소개하기_삽화.png",
    "나라 소개_외국 생활을 시작하며 나라 소개하기_삽화.png",
    "default2.png",
  ];

  const [level, setLevel] = useState("초급 1");
  const [time, setTime] = useState("60분");
  const [content, setContent] = useState([]);
  const [topic, setTopic] = useState([]);
  const [functionality, setFunctionality] = useState([]);
  const [activity, setActivityList] = useState([]); // 기존 activity는 제거
  const [mbti, setMbti] = useState("");
  const [syllabus, setSyllabus] = useState("");
  const [method, setMethod] = useState("");
  const [summary, setSummary] = useState("");
  const [lesson, setLesson] = useState("");
  const [lessonSections, setLessonSections] = useState([]);
  const [showSummaryModal, setShowSummaryModal] = useState(false); // ⬅️ 추가된 부분
  const [showLessonModal, setShowLessonModal] = useState(false);
  const [showCopyAlert, setShowCopyAlert] = useState(false);
  const [showExampleModal, setShowExampleModal] = useState(false);
  const [selectedExampleSentences, setSelectedExampleSentences] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [showTopicImage, setShowTopicImage] = useState(false);
  const [selectedImageForLesson, setSelectedImageForLesson] = useState([]); // 배열로 변경
  const [selectedTopicImage, setSelectedTopicImage] = useState(""); // ← 요게 있어야 함
  const [filteredImagesByExamples, setFilteredImagesByExamples] = useState([]);

  const summaryModalRef = useRef(null);
  const lessonModalRef = useRef(null);
  const copyAlertRef = useRef(null);
  const imageModalRef = useRef(null); // 추가된 부분
  const pdfRef = useRef(null);

  const [isGrammarFocused, setIsGrammarFocused] = useState(false);
  const [isTopicFocused, setIsTopicFocused] = useState(false);
  const [isFunctionalityFocused, setIsFunctionalityFocused] = useState(false);


  const GRAMMAR_OPTIONS = [
    "이에요/예요", "은/는", "이/가", "이/가 아니다", "-습니다 / -습니까",
    "을/를", "도", "과/와, 하고", "왜", "-아요 / -어요"
  ];

  const TOPIC_OPTIONS = [
    "자기소개", "가족과 직업", "취미 및 선호", "학교 및 교육 환경",
    "날씨 및 계절", "친구 및 관계", "장소 및 위치", "주말 활동",
    "운동과 취미", "약속 및 시간 표현"
  ];

  const FUNCTIONALITY_OPTIONS = [
    "기본 인사 및 작별 표현", "가족 소개 및 직업 표현", "좋아하는 것 표현",
    "학교 관련 어휘 및 문장 표현", "날씨와 계절 표현"
  ];

  const EXAMPLE_SENTENCES = {
    // 📘 문법 (GRAMMAR_OPTIONS)
    "이에요/예요": ["저는 학생이에요.", "여기는 도서관이에요."],
    "은/는": ["저는 한국 사람이에요.", "이것은 책이에요."],
    "이/가": ["누가 왔어요?", "동생이 학교에 가요."],
    "이/가 아니다": ["저는 의사가 아니에요.", "여기는 병원이 아니에요."],
    "-습니다 / -습니까": ["저는 회사에 다닙니다.", "이것은 사과입니까?"],
    "을/를": ["물을 마셔요.", "빵을 먹어요."],
    "도": ["저도 학생이에요.", "이것도 예뻐요."],
    "과/와, 하고": ["친구와 영화를 봐요.", "사과하고 바나나를 샀어요."],
    "왜": ["왜 늦었어요?", "왜 웃어요?"],
    "-아요 / -어요": ["무엇을 해요?", "학교에 가요."],

    // 🧩 주제 (TOPIC_OPTIONS)
    "자기소개": ["안녕하세요. 저는 민수입니다.", "한국에서 왔어요."],
    "가족과 직업": ["아버지는 의사예요.", "우리 가족은 네 명이에요."],
    "취미 및 선호": ["제 취미는 독서예요.", "음악 듣는 것을 좋아해요."],
    "학교 및 교육 환경": ["저는 대학교에 다녀요.", "우리 반은 열 명이에요."],
    "날씨 및 계절": ["오늘은 맑아요.", "겨울에는 눈이 와요."],
    "친구 및 관계": ["친구와 자주 만나요.", "우리는 오래된 친구예요."],
    "장소 및 위치": ["학교는 집 옆에 있어요.", "도서관은 2층에 있어요."],
    "주말 활동": ["주말에 산책해요.", "영화를 봤어요."],
    "운동과 취미": ["수영을 해요.", "등산을 좋아해요."],
    "약속 및 시간 표현": ["내일 만날까요?", "세 시에 약속이 있어요."],

    // 🎯 기능 (FUNCTIONALITY_OPTIONS)
    "기본 인사 및 작별 표현": ["안녕하세요!", "안녕히 가세요."],
    "가족 소개 및 직업 표현": ["이분은 제 아버지예요.", "어머니는 선생님이에요."],
    "좋아하는 것 표현": ["저는 커피를 좋아해요.", "운동하는 것을 좋아해요."],
    "학교 관련 어휘 및 문장 표현": ["수업이 아홉 시에 시작해요.", "오늘은 영어 수업이 있어요."],
    "날씨와 계절 표현": ["가을에는 단풍이 예뻐요.", "여름에는 더워요."]
  };

  const EXAMPLE_IMAGE_MAP = {
    "저는 학생이에요.": ["/images/topics/나라 소개_비즈니스 미팅에서 나라 특징 설명하기_삽화.png", "/images/topics/나라 소개_비즈니스 미팅에서 나라 특징 설명하기_삽화.png"],
    "오늘 날씨가 좋아요.": ["/images/topics/나라 소개_비즈니스 미팅에서 나라 특징 설명하기_삽화.png"]
  };

  const exampleList = [...content, ...topic, ...functionality]
    .flatMap(key => EXAMPLE_SENTENCES[key] || []);
  // 입력값 상태
  const [grammarInput, setGrammarInput] = useState("");
  const [topicInput, setTopicInput] = useState("");
  const [functionalityInput, setFunctionalityInput] = useState("");

  // 필터링된 리스트 상태
  const [filteredGrammarOptions, setFilteredGrammarOptions] = useState([]);
  const [filteredTopicOptions, setFilteredTopicOptions] = useState([]);
  const [filteredFunctionalityOptions, setFilteredFunctionalityOptions] = useState([]);

  // 필터링 핸들러
  const handleGrammarChange = (e) => {
    const value = e.target.value;
    setGrammarInput(value);
    const filtered = GRAMMAR_OPTIONS.filter(opt => opt.includes(value)).filter(opt => !content.includes(opt));
    setFilteredGrammarOptions(filtered);
  };

  const handleGrammarSelect = (option) => {
    if (!content.includes(option)) {
      setContent(prev => [...prev, option]);
    }
    setGrammarInput(""); // 입력값 초기화
    setFilteredGrammarOptions([]);
  };

  const handleTopicChange = (e) => {
    const value = e.target.value;
    setTopicInput(value);
    const filtered = TOPIC_OPTIONS.filter(opt => opt.includes(value)).filter(opt => !topic.includes(opt));
    setFilteredTopicOptions(filtered);
  };

  const handleTopicSelect = (option) => {
    if (!topic.includes(option)) {
      setTopic(prev => [...prev, option]);
    }
    setTopicInput("");
    setFilteredTopicOptions([]);
  };

  const handleFunctionalityChange = (e) => {
    const value = e.target.value;
    setFunctionalityInput(value);
    const filtered = FUNCTIONALITY_OPTIONS.filter(opt => opt.includes(value)).filter(opt => !functionality.includes(opt));
    setFilteredFunctionalityOptions(filtered);
  };

  const handleFunctionalitySelect = (option) => {
    if (!functionality.includes(option)) {
      setFunctionality(prev => [...prev, option]);
    }
    setFunctionalityInput("");
    setFilteredFunctionalityOptions([]);
  };


  useEffect(() => {
    // 모달 바깥 클릭 감지 핸들러
    const handleClickOutside = (event) => {
      if (
        showSummaryModal &&
        summaryModalRef.current &&
        !summaryModalRef.current.contains(event.target)
      ) {
        setShowSummaryModal(false);
      }

      if (
        showLessonModal &&
        lessonModalRef.current &&
        !lessonModalRef.current.contains(event.target)
      ) {
        setShowLessonModal(false);
      }

      if (
        showCopyAlert &&
        copyAlertRef.current &&
        !copyAlertRef.current.contains(event.target)
      ) {
        setShowCopyAlert(false);
      }
      if (
        showTopicImage &&
        imageModalRef.current &&
        !imageModalRef.current.contains(event.target)
      ) {
        setShowTopicImage(false);
      }

    };

    document.addEventListener("mousedown", handleClickOutside);

    // ✅ 주제(topic)에 따른 이미지 자동 설정
    if (topic.length > 0) {
      const keyword = topic[0];
      const matched = topicImages.find((file) => file.includes(keyword));
      const imagePath = matched
        ? encodeURI(`/images/topics/${matched}`)
        : "/images/topics/default.png";

      setSelectedTopicImage(imagePath);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSummaryModal, showLessonModal, showCopyAlert, showTopicImage, topic]);


  const handleShowImage = () => {
    const relatedImages = selectedExampleSentences
      .flatMap(sentence => EXAMPLE_IMAGE_MAP[sentence] || []);

    const uniqueImages = [...new Set(relatedImages)]; // 중복 제거

    setFilteredImagesByExamples(uniqueImages);
    setShowTopicImage(true); // 이미지 모달 열기
  };

  const handleGenerate = async () => {
    setIsLoading(true); // 🔄 로딩 시작

    const lessonData = {
      level,
      time,
      content,
      topic,
      functionality,
      activity,
      mbti,
      syllabus,
      method,
    };

    // API 요청
    try {
      // 첫 번째 요청: 교안 요약 생성
      const summaryResponse = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer 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`,
        },
        body: JSON.stringify({
          model: 'gpt-4o',
          messages: [
            { role: "system", content: "You are an assistant that generates lesson plans based on given data." },
            { role: "user", content: generateLessonPlanPrompt(lessonData) },
          ],
          max_tokens: 1500,
        }),
      });

      const summaryData = await summaryResponse.json();
      console.log('Summary Response:', summaryData);  // 응답 확인

      const summaryContent = summaryData.choices[0].message.content.trim();
      setSummary(summaryContent); // 첫 번째 응답: 요약

      // 모든 section (도입, 제시, 활용, 연습, 마무리) 요청
      const sections = ['도입', '제시', '활용', '연습', '마무리'];
      const responses = await Promise.all(sections.map(async (section) => {
        const sectionResponse = await fetch('https://api.openai.com/v1/chat/completions', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer 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`,
          },
          body: JSON.stringify({
            model: 'gpt-4o',
            messages: [
              { role: "system", content: "You are an assistant that generates lesson plans based on given data." },
              { role: "user", content: `이전에 생성된 요약을 바탕으로 수업 교안의 '${section}' 부분을 작성해주세요: ${summaryContent}. 최대한 상세하게 작성하되 한국어로만 답변해주세요. 그리고 수업 시간을 이전에 생성된 요약에 맞춰서 작성해주세요.` },
            ],
            max_tokens: 2000,
          }),
        });

        const sectionData = await sectionResponse.json();
        return { section, content: sectionData.choices[0].message.content.trim() };
      }));

      // 응답을 수집하여 각 부분별로 교안 작성
      let lessonContent = '';
      responses.forEach(response => {
        lessonContent += `\n\n${response.section}:\n${response.content}`;
      });

      setLesson(lessonContent); // 전체 교안 내용 업데이트
      setLessonSections(responses);

    } catch (error) {
      console.error('OpenAI API 요청 실패:', error);
    }
    finally {
      setIsLoading(false); // ✅ 로딩 종료
    }
  };

  const generateLessonPlanPrompt = (data) => {
    return `
      생성하려는 교안은 다음의 정보를 기반으로 작성됩니다:
      - 학습자 수준: ${data.level}
      - 수업 시간: ${data.time}
      - 문법 및 표현: ${data.content.join(', ')}
      - 주제 및 화제: ${data.topic.join(', ')}
      - 기능 및 과제: ${data.functionality.join(', ')}
      - 수업 활동: ${data.activity}
      - 학습 MBTI: ${data.mbti}
      - 교수 요목: ${data.syllabus}
      - 적용 교수법: ${data.method}

      위의 정보에 맞는 교안을 생성해 주세요. 한국어로만 답변해주세요. 양식은 아래와 같아요.
      -학습목표1,2,3,4
      -수업 내용 요약 도입, 제시,활용, 연습, 마무리
      수업 시간이 30분인 경우, 도입 시간은 3분, 제시 시간은 5분, 활용 시간은 5분, 연습 시간은 15분, 마무리 시간은 2분으로 설정해주세요.
      수업 시간이 60분인 경우, 도입 시간은 5분, 제시 시간은 10분, 활용 시간은 10분, 연습 시간은 20분, 마무리 시간은 5분으로 설정해주세요.
    `;
  };

  const handleReset = () => {
    setLevel("");
    setTime("");
    setContent([]);
    setTopic([]);
    setFunctionality([]);
    setActivityList([]); // 수정: 올바른 상태 업데이트 함수 사용
    setMbti("");
    setSyllabus("");
    setMethod("");
    setSummary("");
    setLesson("");
  };

  const downloadPDF = () => {
    setIsLoading(true); // 🔄 로딩 시작
    document.body.style.overflow = "hidden"; // ✅ 스크롤 막기

    import("html2pdf.js").then((html2pdf) => {
      // 수업 구성 테이블 행만 먼저 생성
      const lessonTableRows = lessonSections.map(sec => `
        <tr>
          <td style="padding: 10px; font-weight: bold;">${sec.section}</td>
          <td style="padding: 10px; white-space: pre-line;">${sec.content}</td>
        </tr>
      `).join('');

      // 이미지 HTML (있을 경우만 출력)
      const imageSection = selectedImageForLesson.length > 0 ? `
      <h2 style="font-size: 18px; border-bottom: 2px solid #ccc; padding-bottom: 5px; margin-top: 25px;">5. 주제 이미지</h2>
      <div style="
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: 10px;
        margin-top: 15px;
      ">
        ${selectedImageForLesson.map(src => `
          <img 
            src="${src}" 
            alt="선택된 이미지" 
            style="
              width: 100%;
              height: auto;
              border-radius: 8px;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            " 
          />
        `).join('')}
      </div>
    ` : '';

      // ✅ 예문 섹션 생성
      const exampleSection = selectedExampleSentences.length > 0 ? `
<h2 style="font-size: 18px; border-bottom: 2px solid #ccc; padding-bottom: 5px; margin-top: 25px;">5. 예문</h2>
<ul style="margin-left: 20px; line-height: 1.8;">
  ${selectedExampleSentences.map(ex => `<li>${ex}</li>`).join('')}
</ul>
` : '';


      // 전체 PDF HTML 콘텐츠
      const pdfContent = `
        <div style="font-family: 'Arial', sans-serif; padding: 30px; line-height: 1.7; font-size: 14px;">
          <h1 style="text-align: center; font-size: 22px; margin-bottom: 30px;">📘 수업안 (Lesson Plan)</h1>
  
          <h2 style="font-size: 18px; border-bottom: 2px solid #ccc; padding-bottom: 5px; margin-top: 20px;">1. 수업 정보</h2>
          <p><strong>학습자 수준:</strong> ${level}</p>
          <p><strong>수업 시간:</strong> ${time}</p>
          <p><strong>교수 요목:</strong> ${syllabus}</p>
          <p><strong>적용 교수법:</strong> ${method}</p>
          <p><strong>학습자 MBTI:</strong> ${mbti}</p>
  
          <h2 style="font-size: 18px; border-bottom: 2px solid #ccc; padding-bottom: 5px; margin-top: 25px;">2. 수업 목표</h2>
          <p><strong>문법 및 표현:</strong> ${content}</p>
          <p><strong>주제 및 화제:</strong> ${topic}</p>
          <p><strong>기능 및 과제:</strong> ${functionality}</p>
  
          <h2 style="font-size: 18px; border-bottom: 2px solid #ccc; padding-bottom: 5px; margin-top: 25px;">3. 수업 활동</h2>
          <table style="width: 100%; border-collapse: collapse; margin-top: 10px;" border="1">
            <thead>
              <tr style="background-color: #f0f0f0;">
                <th style="padding: 10px; width: 25%;">구분</th>
                <th style="padding: 10px;">내용</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="padding: 10px; font-weight: bold;">활동 유형</td>
                <td style="padding: 10px;">${activity}</td>
              </tr>
              <tr>
                <td style="padding: 10px; font-weight: bold;">요약</td>
                <td style="padding: 10px; white-space: pre-line;">${summary}</td>
              </tr>
            </tbody>
          </table>
  
          <h2 style="font-size: 18px; border-bottom: 2px solid #ccc; padding-bottom: 5px; margin-top: 25px;">4. 수업 구성</h2>
          <table style="width: 100%; border-collapse: collapse; margin-top: 10px;" border="1">
            <thead>
              <tr style="background-color: #f0f0f0;">
                <th style="padding: 10px; width: 20%;">단계</th>
                <th style="padding: 10px;">내용</th>
              </tr>
            </thead>
            <tbody>
              ${lessonTableRows}
            </tbody>
          </table>
          ${exampleSection}
          ${imageSection}
        </div>
      `;

      // PDF 생성
      const tempElement = document.createElement("div");
      tempElement.innerHTML = pdfContent;
      document.body.appendChild(tempElement);

      const opt = {
        margin: 0.5,
        filename: `교안_${new Date().toISOString().slice(0, 10)}.pdf`,
        image: { type: "png", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };

      html2pdf.default().set(opt).from(tempElement).save().then(() => {
        document.body.removeChild(tempElement);
        pdfRef.current = null;
        setIsLoading(false); // 🔄 로딩 종료
      });
    });
  };

  const downloadWord = async () => {
    const {
      Document,
      Packer,
      Paragraph,
      Table,
      TableRow,
      TableCell,
      WidthType,
      TextRun,
      HeadingLevel,
      AlignmentType,
      ImageRun,
    } = await import("docx");

    // 이미지 버퍼 가져오기
    const fetchImageBuffer = async (url) => {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("이미지 요청 실패");
        const blob = await response.blob();
        return await blob.arrayBuffer();
      } catch (e) {
        console.warn("이미지 버퍼 로딩 실패:", url, e);
        return null;
      }
    };

    const exampleSection = selectedExampleSentences.length > 0 ? [
      new Paragraph({ text: "5. 예문", heading: HeadingLevel.HEADING_2 }),
      ...selectedExampleSentences.map(sentence =>
        new Paragraph({
          text: sentence,
          bullet: { level: 0 }, // 리스트 스타일
        })
      )
    ] : [];
    // 이미지 섹션 테이블 생성 (선택한 이미지 수에 맞춰 열 개수를 동적으로 결정)
    const makeImageSection = async () => {
      if (!selectedImageForLesson || selectedImageForLesson.length === 0) return [];

      const imageCells = await Promise.all(
        selectedImageForLesson.map(async (img) => {
          const buffer = await fetchImageBuffer(img);
          return new TableCell({
            children: [
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: buffer
                  ? [
                    new ImageRun({
                      data: buffer,
                      transformation: { width: 160, height: 100 },
                    }),
                  ]
                  : [new TextRun("이미지 없음")],
              }),
            ],
          });
        })
      );

      // 선택한 이미지 수 만큼 열을 가지도록 chunk size를 동적으로 결정
      const chunkSize = selectedImageForLesson.length;
      const rowChunks = [];
      for (let i = 0; i < imageCells.length; i += chunkSize) {
        const row = imageCells.slice(i, i + chunkSize);
        // 빈 셀 추가 없음
        rowChunks.push(new TableRow({ children: row }));
      }

      return [
        new Paragraph({ text: "6. 주제 이미지", heading: HeadingLevel.HEADING_2 }),
        new Table({ width: { size: 100, type: WidthType.PERCENTAGE }, rows: rowChunks }),
      ];
    };

    // 수업 구성 테이블
    const lessonTable = new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: lessonSections.map((s) =>
        new TableRow({
          children: [
            new TableCell({
              width: { size: 25, type: WidthType.PERCENTAGE },
              children: [new Paragraph({ text: s.section })],
            }),
            new TableCell({
              children: s.content.split('\n').map((line) => new Paragraph({ text: line })),
            }),
          ],
        })
      ),
    });

    const activityTable = new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: [
        new TableRow({
          children: [
            new TableCell({
              width: { size: 25, type: WidthType.PERCENTAGE },
              children: [new Paragraph({ children: [new TextRun({ text: "활동 유형", bold: true })] })],
            }),
            new TableCell({
              children: [new Paragraph(Array.isArray(activity) ? activity.join(", ") : activity || "없음")],
            }),
          ],
        }),
        new TableRow({
          children: [
            new TableCell({
              width: { size: 25, type: WidthType.PERCENTAGE },
              children: [new Paragraph({ children: [new TextRun({ text: "요약", bold: true })] })],
            }),
            new TableCell({
              children: (summary || "없음").split('\n').map((line) => new Paragraph({ text: line })),
            }),
          ],
        }),
      ],
    });

    const imageSection = await makeImageSection();

    const doc = new Document({
      sections: [
        {
          children: [
            new Paragraph({ text: "1. 수업 정보", heading: HeadingLevel.HEADING_2 }),
            new Paragraph({ text: `학습자 수준: ${level}` }),
            new Paragraph({ text: `수업 시간: ${time}` }),
            new Paragraph({ text: `교수 요목: ${syllabus}` }),
            new Paragraph({ text: `적용 교수법: ${method}` }),
            new Paragraph({ text: `학습자 MBTI: ${mbti}` }),
            new Paragraph({ text: "2. 수업 목표", heading: HeadingLevel.HEADING_2 }),
            new Paragraph({ text: `문법 및 표현: ${content.join(", ")}` }),
            new Paragraph({ text: `주제 및 화제: ${topic.join(", ")}` }),
            new Paragraph({ text: `기능 및 과제: ${functionality.join(", ")}` }),
            new Paragraph({ text: "3. 수업 활동", heading: HeadingLevel.HEADING_2 }),
            activityTable,
            new Paragraph({ text: "4. 수업 구성", heading: HeadingLevel.HEADING_2 }),
            lessonTable,
            ...exampleSection,
            ...imageSection,
          ],
        },
      ],
    });

    const blob = await Packer.toBlob(doc);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `교안_${new Date().toISOString().slice(0, 10)}.docx`;
    link.click();
  };

  const handleContentAdd = (e) => {
    const newValue = e.target.value.trim(); // 공백 제거
    if (e.key === "Enter" && newValue) {
      setContent((prev) => [...prev, newValue]);
      e.target.value = ""; // 입력 필드 초기화
    }
  };

  // 주제 추가 함수
  const handleTopicAdd = (e) => {
    const newValue = e.target.value.trim(); // 공백 제거
    if (e.key === "Enter" && newValue) {
      setTopic((prev) => [...prev, newValue]);
      e.target.value = ""; // 입력 필드 초기화
    }
  };

  // 기능 및 과제 추가 함수
  const handleFunctionalityAdd = (e) => {
    const newValue = e.target.value.trim(); // 공백 제거
    if (e.key === "Enter" && newValue) {
      setFunctionality((prev) => [...prev, newValue]);
      e.target.value = ""; // 입력 필드 초기화
    }
  };

  const handleTagRemove = (tag, setState, state) => {
    setState(state.filter(item => item !== tag));  // 태그 삭제
  };

  const showAudioAlert = () => {
    alert("서비스 준비 중입니다. 곧 제공될 예정입니다.");
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <header className="w-full bg-white shadow-sm px-6 py-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-purple-700">Langustory</h1>
        <nav className="hidden md:flex space-x-8 text-gray-700 font-medium">
          <a href="#" className="hover:text-purple-600">서비스 소개</a>
          <a href="#" className="hover:text-purple-600">교육 도구</a>
          <a href="#" className="hover:text-purple-600">커뮤니티</a>
          <a href="#" className="hover:text-purple-600">구매</a>
        </nav>
        <div className="flex items-center space-x-4">
          <Bell size={20} className="text-gray-500" />
          <Mail size={20} className="text-gray-500" />
          <UserCircle size={32} className="text-gray-500" />
        </div>
      </header>

      <div className="flex flex-1">
        <aside className="w-64 bg-white shadow-md p-4">
          <nav className="space-y-4">
            <div>
              <h3 className="text-gray-500 text-sm flex items-center gap-2">
                <BookOpen size={16} /> 교안 생성
              </h3>
              <ul className="mt-2 ml-4 text-sm">
                <li className="bg-purple-100 text-purple-800 font-semibold rounded px-3 py-2">교안 생성</li>
                <li className="text-gray-600 hover:text-purple-600 px-3 py-1">교안 생성 이력</li>
              </ul>
            </div>
            <div>
              <h3 className="text-gray-500 text-sm flex items-center gap-2">
                <Layers size={16} /> 예문 생성 <ChevronDown size={14} />
              </h3>
            </div>
            <div>
              <h3 className="text-gray-500 text-sm flex items-center gap-2">
                <Layers size={16} /> 활동 생성
              </h3>
            </div>
          </nav>
        </aside>

        <main className="flex-1 p-6 grid grid-cols-1 xl:grid-cols-2 gap-6">
          <section className="bg-white rounded-2xl shadow p-6 space-y-6">
            <h3 className="text-xl font-bold">교안 생성 조건</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">학습자 수준 *</label>
                <select className="w-full border rounded px-3 py-2" value={level} onChange={(e) => setLevel(e.target.value)}>
                  <option>초급 1</option>
                  <option>초급 2</option>
                  <option>중급 1</option>
                  <option>중급 2</option>
                  <option>고급 1</option>
                  <option>고급 2</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">수업 시간 *</label>
                <select className="w-full border rounded px-3 py-2" value={time} onChange={(e) => setTime(e.target.value)}>
                  <option>30분</option>
                  <option>60분</option>
                </select>
              </div>
              <div className="relative">
                <label className="block text-sm font-medium mb-1">문법 및 표현 *</label>
                <input
                  className="w-full border rounded px-3 py-2 pr-10"
                  value={grammarInput}
                  onChange={handleGrammarChange}
                  onFocus={() => {
                    setIsGrammarFocused(true);
                    const filtered = GRAMMAR_OPTIONS.filter(opt => !content.includes(opt));
                    setFilteredGrammarOptions(filtered);
                  }}
                  onBlur={() => setTimeout(() => setIsGrammarFocused(false), 100)}
                  placeholder="문법 및 표현 입력"
                />
                <Search className="absolute top-9 right-3 text-gray-400" size={16} />

                {(isGrammarFocused && filteredGrammarOptions.length > 0) && (
                  <ul className="absolute z-10 bg-white border border-gray-300 mt-1 w-full rounded shadow text-sm max-h-48 overflow-auto">
                    {filteredGrammarOptions.map((option, index) => (
                      <li
                        key={index}
                        className="px-4 py-2 hover:bg-purple-100 cursor-pointer"
                        onMouseDown={() => handleGrammarSelect(option)}
                      >
                        {option}
                      </li>
                    ))}
                  </ul>
                )}
              </div>


              <div className="relative">
                <label className="block text-sm font-medium mb-1">주제 및 화제 *</label>
                <input
                  className="w-full border rounded px-3 py-2 pr-10"
                  value={topicInput}
                  onChange={handleTopicChange}
                  onFocus={() => {
                    setIsTopicFocused(true);
                    const filtered = TOPIC_OPTIONS.filter(opt => !topic.includes(opt));
                    setFilteredTopicOptions(filtered);
                  }}
                  onBlur={() => setTimeout(() => setIsTopicFocused(false), 100)}
                  placeholder="주제 및 화제 입력"
                />
                <Search className="absolute top-9 right-3 text-gray-400" size={16} />
                {(isTopicFocused && filteredTopicOptions.length > 0) && (
                  <ul className="absolute z-10 bg-white border border-gray-300 mt-1 w-full rounded shadow text-sm max-h-48 overflow-auto">
                    {filteredTopicOptions.map((option, index) => (
                      <li
                        key={index}
                        className="px-4 py-2 hover:bg-purple-100 cursor-pointer"
                        onMouseDown={() => handleTopicSelect(option)}
                      >
                        {option}
                      </li>
                    ))}
                  </ul>
                )}
              </div>


              <div>
                <label className="block text-sm font-medium mb-1">수업 활동</label>
                <select
                  className="w-full border rounded px-3 py-2"
                  onChange={(e) => {
                    const selected = e.target.value;
                    if (selected && !activity.includes(selected)) {
                      setActivityList((prev) => [...prev, selected]);
                    }
                  }}
                >
                  <option value="">선택하세요</option>
                  <option>듣기</option>
                  <option>말하기</option>
                  <option>쓰기</option>
                  <option>읽기</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">학습 MBTI</label>
                <select
                  className="w-full border rounded px-3 py-2"
                  value={mbti}
                  onChange={(e) => setMbti(e.target.value)}
                >
                  <option value="">선택하세요</option>
                  <option>INTJ</option>
                  <option>INTP</option>
                  <option>ENTJ</option>
                  <option>ENTP</option>
                  <option>INFJ</option>
                  <option>INFP</option>
                  <option>ENFJ</option>
                  <option>ENFP</option>
                  <option>ISTJ</option>
                  <option>ISFJ</option>
                  <option>ESTJ</option>
                  <option>ESFJ</option>
                  <option>ISTP</option>
                  <option>ISFP</option>
                  <option>ESTP</option>
                  <option>ESFP</option>
                </select>
              </div>

              <div className="relative">
                <label className="block text-sm font-medium mb-1">기능 및 과제 *</label>
                <input
                  className="w-full border rounded px-3 py-2 pr-10"
                  value={functionalityInput}
                  onChange={handleFunctionalityChange}
                  onFocus={() => {
                    setIsFunctionalityFocused(true);
                    const filtered = FUNCTIONALITY_OPTIONS.filter(opt => !functionality.includes(opt));
                    setFilteredFunctionalityOptions(filtered);
                  }}
                  onBlur={() => setTimeout(() => setIsFunctionalityFocused(false), 100)}
                  placeholder="기능 및 과제 입력"
                />
                <Search className="absolute top-9 right-3 text-gray-400" size={16} />
                {(isFunctionalityFocused && filteredFunctionalityOptions.length > 0) && (
                  <ul className="absolute z-10 bg-white border border-gray-300 mt-1 w-full rounded shadow text-sm max-h-48 overflow-auto">
                    {filteredFunctionalityOptions.map((option, index) => (
                      <li
                        key={index}
                        className="px-4 py-2 hover:bg-purple-100 cursor-pointer"
                        onMouseDown={() => handleFunctionalitySelect(option)}
                      >
                        {option}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">교수 요목</label>
                <select
                  className="w-full border rounded px-3 py-2"
                  value={syllabus}
                  onChange={(e) => setSyllabus(e.target.value)}
                >
                  <option value="">선택하세요</option>
                  <option>선형 교수 요목</option>
                  <option>나선형 교수 요목</option>
                  <option>기능 중심 교수 요목</option>
                  <option>과업 중심 교수 요목</option>
                  <option>상황 중심 교수 요목</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">적용 교수법</label>
                <select
                  className="w-full border rounded px-3 py-2"
                  value={method}
                  onChange={(e) => setMethod(e.target.value)}
                >
                  <option value="">선택하세요</option>
                  <option>문법번역식</option>
                  <option>직접 교수법</option>
                  <option>청화식 교수법</option>
                  <option>전신 반응 교수법</option>
                  <option>의사소통 중심 교수법</option>
                  <option>과업 중심 교수법</option>
                </select>
              </div>

            </div>

            <div className="mt-6 p-6 bg-white border border-gray-200 rounded-lg shadow-sm space-y-6">
              <h4 className="text-lg font-semibold text-gray-800 border-b pb-2">선택 값 확인</h4>

              {/* 3열 구성 */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm text-gray-800">
                {/* 첫 번째 열 */}
                <div className="space-y-4">
                  {/* 학습자 수준 */}
                  <div>
                    <div className="font-medium text-gray-700 mb-1">학습자 수준 *</div>
                    <div className="bg-gray-50 px-4 min-h-[44px] flex items-center rounded border">{level || "-"}</div>
                  </div>

                  {/* 수업 시간 */}
                  <div>
                    <div className="font-medium text-gray-700 mb-1">수업 시간 *</div>
                    <div className="bg-gray-50 px-4 min-h-[44px] flex items-center rounded border">{time || "-"}</div>
                  </div>

                  {/* 문법 및 표현 */}
                  <div>
                    <div className="font-medium text-gray-700 mb-1">문법 및 표현 *</div>
                    <div className="flex flex-wrap items-start gap-2 bg-gray-50 px-3 py-2 min-h-[44px] h-auto rounded border">
                      {content.length > 0 ? (
                        content.map((item, idx) => (
                          <span key={idx} className="bg-gray-800 text-white px-3 py-1 rounded-full text-sm flex items-center">
                            {item}
                            <button className="ml-2 text-xs" onClick={() => handleTagRemove(item, setContent, content)}>✕</button>
                          </span>
                        ))
                      ) : <span className="text-gray-400">-</span>}
                    </div>
                  </div>
                </div>

                {/* 두 번째 열 */}
                <div className="space-y-4">
                  {/* 주제 및 화제 */}
                  <div>
                    <div className="font-medium text-gray-700 mb-1">주제 및 화제 *</div>
                    <div className="flex flex-wrap items-start gap-2 bg-gray-50 px-3 py-2 min-h-[44px] h-auto rounded border">
                      {topic.length > 0 ? (
                        topic.map((item, idx) => (
                          <span key={idx} className="bg-gray-800 text-white px-3 py-1 rounded-full text-sm flex items-center">
                            {item}
                            <button className="ml-2 text-xs" onClick={() => handleTagRemove(item, setTopic, topic)}>✕</button>
                          </span>
                        ))
                      ) : <span className="text-gray-400">-</span>}
                    </div>
                  </div>

                  {/* 수업 활동 */}
                  <div>
                    <div className="font-medium text-gray-700 mb-1">수업 활동</div>
                    <div className="flex flex-wrap items-start gap-2 bg-gray-50 px-3 py-2 min-h-[44px] h-auto rounded border">
                      {activity.length > 0 ? (
                        activity.map((item, idx) => (
                          <span key={idx} className="bg-gray-800 text-white px-3 py-1 rounded-full text-sm flex items-center">
                            {item}
                            <button className="ml-2 text-xs" onClick={() => setActivityList(activity.filter((v) => v !== item))}>✕</button>
                          </span>
                        ))
                      ) : <span className="text-gray-400">-</span>}
                    </div>
                  </div>

                  {/* 학습자 MBTI */}
                  <div>
                    <div className="font-medium text-gray-700 mb-1">학습자 MBTI</div>
                    <div className="bg-gray-50 px-4 min-h-[44px] flex items-center rounded border">{mbti || "선택 안 됨"}</div>
                  </div>
                </div>

                {/* 세 번째 열 */}
                <div className="space-y-4">
                  {/* 기능 및 과제 */}
                  <div>
                    <div className="font-medium text-gray-700 mb-1">기능 및 과제 *</div>
                    <div className="flex flex-wrap items-start gap-2 bg-gray-50 px-3 py-2 min-h-[44px] h-auto rounded border">
                      {functionality.length > 0 ? (
                        functionality.map((item, idx) => (
                          <span key={idx} className="bg-gray-800 text-white px-3 py-1 rounded-full text-sm flex items-center">
                            {item}
                            <button className="ml-2 text-xs" onClick={() => handleTagRemove(item, setFunctionality, functionality)}>✕</button>
                          </span>
                        ))
                      ) : <span className="text-gray-400">-</span>}
                    </div>
                  </div>

                  {/* 교수 요목 */}
                  <div>
                    <div className="font-medium text-gray-700 mb-1">교수 요목 (선택 사항)</div>
                    <div className="bg-gray-50 px-4 min-h-[44px] flex items-center rounded border">{syllabus || "-"}</div>
                  </div>

                  {/* 적용 교수법 */}
                  <div>
                    <div className="font-medium text-gray-700 mb-1">적용 교수법 (선택 사항)</div>
                    <div className="bg-gray-50 px-4 min-h-[44px] flex items-center rounded border">{method || "-"}</div>
                  </div>
                </div>
              </div>

              {/* 하단 버튼 */}
              <div className="flex flex-col md:flex-row justify-between items-center pt-6">
                <div className="text-sm text-gray-500 mb-3 md:mb-0">소모 크레딧 : 000개</div>
                <div className="flex gap-3">
                  <button onClick={handleGenerate} className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-full shadow">교안 생성하기</button>
                  <button onClick={handleReset} className="border border-gray-300 px-6 py-2 rounded-full text-gray-700">Reset</button>
                </div>
              </div>
            </div>
          </section>

          <section className="bg-white rounded-2xl shadow p-6 space-y-6" id="result-area">
            <h3 className="text-xl font-bold">교안 생성 결과</h3>

            {/* ✅ 요약 영역 + 아이콘 */}
            <div>
              <div className="flex justify-between items-center mb-1">
                <h4 className="text-md font-semibold text-gray-800">요약</h4>
                <div className="flex items-center gap-2">
                  <Expand
                    size={18}
                    className="text-gray-500 hover:text-purple-600 cursor-pointer"
                    onClick={() => setShowSummaryModal(true)}
                    title="요약 전체 보기"
                  />
                  <Copy
                    size={18}
                    className="text-gray-500 hover:text-blue-600 cursor-pointer"
                    onClick={() => {
                      navigator.clipboard.writeText(summary);
                      setShowCopyAlert(true); // ✅ 알림 표시
                    }}
                    title="요약 복사"
                  />
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded text-sm whitespace-pre-wrap leading-relaxed min-h-[250px] max-h-[250px] overflow-y-auto">
                {summary || "학습 목표: 학습 목표를 복사해서 여기에 표시합니다."}
              </div>
            </div>

            {/* ✅ 수업 교안 + 아이콘 */}
            <div>
              <div className="flex justify-between items-center mb-1">
                <h4 className="text-md font-semibold text-gray-800">수업 교안</h4>
                <div className="flex items-center gap-2">
                  <Expand
                    size={18}
                    ref={copyAlertRef}
                    className="text-gray-500 hover:text-purple-600 cursor-pointer"
                    onClick={() => setShowLessonModal(true)}
                    title="수업 교안 전체 보기"
                  />
                  <FileText
                    size={18}
                    className="text-gray-500 hover:text-indigo-600 cursor-pointer"
                    onClick={() => setShowExampleModal(true)}
                    title="예문 불러오기"
                  />
                  {/* 이미지 불러오기 */}
                  <Image
                    size={18}
                    className="text-gray-500 hover:text-green-600 cursor-pointer"
                    onClick={handleShowImage}
                    title="이미지 불러오기"
                  />
                  <Copy
                    size={18}
                    ref={copyAlertRef}
                    className="text-gray-500 hover:text-blue-600 cursor-pointer"
                    onClick={() => {
                      navigator.clipboard.writeText(lesson);
                      setShowCopyAlert(true); // ✅ 알림 표시
                    }}
                    title="수업 교안 복사"
                  />
                </div>
              </div>
              <div className="bg-gray-100 p-4 rounded text-sm whitespace-pre-wrap leading-relaxed min-h-[300px] max-h-[300px] overflow-y-auto">
                {lesson || "수업 내용 활동: 여기에는 수업에서 진행할 활동이 나열됩니다. 목록, 인용 등 포맷 적용 가능."}
              </div>
            </div>

            {/* 버튼 */}
            <div className="flex flex-wrap gap-3 justify-end">
              <button onClick={downloadPDF} className="bg-purple-600 hover:bg-purple-700 text-white px-5 py-2 rounded-full shadow">PDF 파일 생성</button>
              <button onClick={downloadWord} className="border border-gray-300 px-5 py-2 rounded-full text-gray-700">WORD 파일 생성</button>
              <button onClick={showAudioAlert} className="border px-5 py-2 rounded-full text-gray-700">듣기 예문 오디오 다운로드</button>
            </div>
          </section>

          {/* ✅ 요약 모달 */}
          {showSummaryModal && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div
                ref={summaryModalRef}
                className="bg-white w-full max-w-3xl p-6 rounded-xl shadow-lg relative max-h-[90vh] overflow-y-auto"
              >
                <button
                  onClick={() => setShowSummaryModal(false)}
                  className="absolute top-3 right-4 text-gray-500 hover:text-red-500 text-xl"
                >
                  ×
                </button>
                <h3 className="text-lg font-semibold mb-4">📄 요약 전체 보기</h3>
                <div className="text-sm whitespace-pre-wrap leading-relaxed text-gray-800">
                  {summary || "요약 결과가 없습니다."}
                </div>
              </div>
            </div>
          )}

          {/* ✅ 수업 교안 모달 */}
          {showLessonModal && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div
                ref={lessonModalRef}
                className="bg-white w-full max-w-2xl p-6 rounded-xl shadow-lg relative max-h-[80vh] overflow-y-auto"
              >
                <button
                  onClick={() => setShowLessonModal(false)}
                  className="absolute top-3 right-4 text-gray-500 hover:text-red-500 text-xl"
                >
                  ×
                </button>
                <h3 className="text-lg font-semibold mb-4">📘 수업 교안 전체 보기</h3>
                <div className="whitespace-pre-wrap text-sm text-gray-800 leading-relaxed">
                  {lesson || "요약 결과가 없습니다."}
                </div>
              </div>
            </div>
          )}
          {showExampleModal && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div className="bg-white w-full max-w-2xl p-6 rounded-xl shadow-lg relative max-h-[80vh] overflow-y-auto">
                <button
                  onClick={() => setShowExampleModal(false)}
                  className="absolute top-3 right-4 text-gray-500 hover:text-red-500 text-xl"
                >
                  ×
                </button>

                <h3 className="text-lg font-semibold mb-4">📝 예문 선택</h3>

                {exampleList.length > 0 ? (
                  <ul className="space-y-2">
                    {exampleList.map((ex, i) => (
                      <li key={i} className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          checked={selectedExampleSentences.includes(ex)}
                          onChange={() => {
                            setSelectedExampleSentences(prev =>
                              prev.includes(ex)
                                ? prev.filter(e => e !== ex)
                                : [...prev, ex]
                            );
                          }}
                        />
                        <span className="text-sm text-gray-700">{ex}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-sm text-gray-500">선택된 항목과 관련된 예문이 없습니다.</p>
                )}
              </div>
            </div>
          )}


          {showCopyAlert && (
            <div
              ref={copyAlertRef}
              className="fixed top-[20%] left-1/2 transform -translate-x-1/2 bg-white border border-gray-300 px-4 py-2 rounded shadow z-[100]"
            >
              ✅ 복사되었습니다!
            </div>
          )}
          {isLoading && (
            <div className="fixed inset-0 bg-black bg-opacity-40 z-[9999] flex items-center justify-center">
              <div className="flex flex-col items-center gap-3">
                <div className="animate-spin h-12 w-12 border-t-4 border-purple-600 border-solid rounded-full"></div>
                <p className="text-white text-sm mt-2">교안을 생성 중입니다...</p>
              </div>
            </div>
          )}

          {showTopicImage && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div ref={imageModalRef}  // ref 추가
                className="bg-white p-6 rounded-xl w-full max-w-5xl relative shadow-lg">
                <button
                  onClick={() => setShowTopicImage(false)}
                  className="absolute top-3 right-4 text-gray-500 hover:text-red-500 text-xl"
                >
                  ×
                </button>
                <h3 className="text-lg font-semibold mb-4">📷 주제 관련 이미지</h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                  {(filteredImagesByExamples.length > 0 ? filteredImagesByExamples : topicImages).map((img, idx) => {
                    const imagePath = encodeURI(img.includes("/images/") ? img : `/images/topics/${img}`);

                    return (
                      <img
                        key={idx}
                        src={imagePath}
                        alt={`주제 이미지 ${idx + 1}`}
                        className={`w-[180px] h-[150px] object-cover rounded shadow cursor-pointer transition duration-200 ${selectedImageForLesson.includes(imagePath) ? 'ring-4 ring-purple-500' : ''
                          }`}
                        onClick={() => {
                          setSelectedImageForLesson((prev) =>
                            prev.includes(imagePath)
                              ? prev.filter((img) => img !== imagePath)
                              : [...prev, imagePath]
                          );
                        }}
                        onError={(e) => (e.currentTarget.src = "/images/topics/default.png")}
                      />
                    );
                  })}
                </div>

              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
